import { Badge, Button, Heading, Layout, Text } from '../../../../components/core';
import { getStylesheet } from '../../../../styles';

type SurveyCardProps = {
  title: string;
  status?: 'active' | 'completed';
  onActionPress?: () => void;
  actionLabel?: string;
  actionTestId: string;
  actionVariant?: 'primary' | 'secondary';
  ariaLabel: string;
  estimatedTime?: string;
};

export const SurveyCard = ({
  title,
  status,
  onActionPress,
  actionLabel,
  actionTestId,
  ariaLabel,
  estimatedTime,
}: SurveyCardProps): JSX.Element => {
  const isActive = status === 'active';
  const isCompleted = status === 'completed';

  const estimatedTimeAriaLabel =
    estimatedTime != null ? `Estimated time to complete: ${estimatedTime} min` : undefined;

  const estimatedTimeVisualText =
    estimatedTime != null ? `Est. time is ${estimatedTime} min` : undefined;

  return (
    <Layout.VStack {...styles.dashboardBox} space={2}>
      {isActive && <Badge.successSubtle {...styles.activeBadge}>Active</Badge.successSubtle>}

      <Heading.h4 level={2}>{title}</Heading.h4>

      {onActionPress !== undefined && actionLabel !== undefined && (
        <Layout.VStack space={2}>
          {isActive && (
            <Button.primaryMedium
              aria-label={ariaLabel}
              isLink
              testID={actionTestId}
              onPress={onActionPress}
            >
              {actionLabel}
            </Button.primaryMedium>
          )}
          {isCompleted && (
            <Button.secondaryMedium
              aria-label={ariaLabel}
              isLink
              testID={actionTestId}
              onPress={onActionPress}
            >
              {actionLabel}
            </Button.secondaryMedium>
          )}
          {estimatedTime != null && (
            <Text.caption aria-label={estimatedTimeAriaLabel} textAlign="center">
              {estimatedTimeVisualText}
            </Text.caption>
          )}
        </Layout.VStack>
      )}
    </Layout.VStack>
  );
};

const styles = getStylesheet({
  activeBadge: {
    alignSelf: 'flex-start',
  },
  dashboardBox: {
    backgroundColor: 'white',
    borderColor: 'secondary.200',
    borderRadius: 8,
    borderWidth: 1,
    gap: 6,
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: 6,
  },
  completedText: {
    color: 'green.600',
  },
});
